var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShareIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_1073_566)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 35554"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 14229",
    d: "M17.667 7.66747C17.667 8.26071 17.8429 8.84064 18.1725 9.3339C18.5021 9.82717 18.9705 10.2116 19.5186 10.4386C20.0667 10.6657 20.6698 10.7251 21.2517 10.6093C21.8335 10.4936 22.368 10.2079 22.7875 9.78844C23.2069 9.36895 23.4926 8.83449 23.6084 8.25264C23.7241 7.6708 23.6647 7.0677 23.4377 6.51961C23.2106 5.97152 22.8262 5.50307 22.3329 5.17348C21.8397 4.84389 21.2597 4.66797 20.6665 4.66797C19.8711 4.66828 19.1083 4.98439 18.5459 5.54684C17.9834 6.10929 17.6673 6.87205 17.667 7.66747Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 14230",
    d: "M17.667 20.6665C17.667 21.2597 17.8429 21.8397 18.1725 22.3329C18.5021 22.8262 18.9705 23.2106 19.5186 23.4377C20.0667 23.6647 20.6698 23.7241 21.2517 23.6084C21.8335 23.4926 22.368 23.2069 22.7875 22.7875C23.2069 22.368 23.4926 21.8335 23.6084 21.2517C23.7241 20.6698 23.6647 20.0667 23.4377 19.5186C23.2106 18.9705 22.8262 18.5021 22.3329 18.1725C21.8397 17.8429 21.2597 17.667 20.6665 17.667C19.8711 17.6673 19.1083 17.9834 18.5459 18.5459C17.9834 19.1083 17.6673 19.8711 17.667 20.6665Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 638",
    d: "M10.324 12.8385L17.9843 9.0083",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 639",
    d: "M17.9831 19.3247L10.3484 15.5073",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 14231",
    d: "M4.66675 14.1675C4.66675 14.7607 4.84267 15.3406 5.17226 15.8339C5.50184 16.3272 5.9703 16.7116 6.51839 16.9386C7.06648 17.1657 7.66958 17.2251 8.25142 17.1093C8.83327 16.9936 9.36773 16.7079 9.78721 16.2884C10.2067 15.8689 10.4924 15.3345 10.6081 14.7526C10.7239 14.1708 10.6644 13.5677 10.4374 13.0196C10.2104 12.4715 9.82595 12.0031 9.33268 11.6735C8.83942 11.3439 8.25949 11.168 7.66625 11.168C6.87083 11.1683 6.10807 11.4844 5.54562 12.0468C4.98317 12.6093 4.66706 13.372 4.66675 14.1675Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1073_566"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/Share_Icon.e6bda61dd87b2d4f90fd88363fe24a2d.svg";
export { ForwardRef as ReactComponent };